import React from 'react';
import '../SpaSite.css';

const CourseDetails = ({ selectedCourse, colors }) => {
  if (!selectedCourse) return null;

  return (
    <div style={{
      padding: '30px',
      flex: '1',
      overflowY: 'auto',
    }}>
      {/* Course description */}
      <div style={{ marginBottom: '25px' }}>
        <h4 style={{
          fontSize: '1.2rem',
          fontWeight: 600,
          color: colors.primary,
          marginBottom: '15px',
          display: 'flex',
          alignItems: 'center',
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '8px' }}>
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          課程內容
        </h4>
        <p style={{
          fontSize: '1rem',
          lineHeight: '1.7',
          color: colors.textDark,
          marginBottom: '15px'
        }}>
          {selectedCourse.fullDescription || selectedCourse.content}
        </p>

        <div style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '10px',
          marginTop: '15px'
        }}>
          {selectedCourse.benefits && selectedCourse.benefits.map((benefit, idx) => (
            <div key={idx} style={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: 'rgba(92, 137, 137, 0.1)',
              padding: '6px 12px',
              borderRadius: '4px',
              fontSize: '0.9rem'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={colors.secondary} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}>
                <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                <polyline points="22 4 12 14.01 9 11.01"></polyline>
              </svg>
              {benefit}
            </div>
          ))}
        </div>
      </div>

      {/* Course Price Section */}
      <div style={{
        padding: '20px',
        borderRadius: '10px',
        backgroundColor: 'rgba(248, 250, 245, 0.8)',
        border: `1px solid rgba(92, 137, 137, 0.2)`,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '25px'
      }}>
        <div>
          <div style={{ fontSize: '0.9rem', color: colors.textLight, marginBottom: '5px' }}>課程價格</div>
          <div style={{
            fontSize: '1.8rem',
            fontWeight: 'bold',
            color: colors.primary
          }}>
            {selectedCourse.price}
          </div>
        </div>
        <div>
          <a
            href="https://page.line.me/535hsnpt?oat_content=url&openQrModal=true"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              padding: '12px 24px',
              backgroundColor: colors.secondary,
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '1rem',
              fontWeight: 600,
              cursor: 'pointer',
              textDecoration: 'none',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            立即預約
          </a>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
